const header = [
  {
    'name': 'Products',
    'id': 0,
    'isActive': false
  },
  {
    'name': 'Details',
    'id': 1,
    'isActive': false
  },
  {
    'name': 'Evaluation',
    'id': 2,
    'isActive': false
  }
]

const evaluation = [
  {
    'name': 'All',
    'id': 1,
    'isActive': false,
    'value': 'total',
    'grade': 0
  },
  {
    'name': 'Good',
    'id': 2,
    'isActive': false,
    'value': 'good',
    'grade': 1
  },
  {
    'name': 'Medium',
    'id': 3,
    'isActive': false,
    'value': 'medium',
    'grade': 2
  },
  {
    'name': 'Bad',
    'id': 4,
    'isActive': false,
    'value': 'bad',
    'grade': 3
  }
]
export {
  header,
  evaluation
}
